import { Link } from "react-router-dom";
import { useState } from "react";
import { ReactComponents } from "@tumbodash/browserPackages";

function Home() {
	const [partyId, setPartyId] = useState("");
	const validId = partyId.length >= 5;

	return (
		<div style={{
			minHeight: "100dvh",
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
			justifyContent: "space-between",
			padding: "var(--space-8) var(--space-5)",
			maxWidth: 420,
			margin: "0 auto",
		}}>
			{/* Top: Logo */}
			<div style={{ textAlign: "center", paddingTop: "var(--space-6)" }}>
				<div style={{ fontSize: 56, fontFamily: "var(--font-display)", fontWeight: 800 }}>
					<ReactComponents.Logo />
				</div>
			</div>

			{/* Middle: Main actions */}
			<div style={{ width: "100%", display: "flex", flexDirection: "column", gap: "var(--space-3)" }}>
				{/* Join — hero action */}
				<div>
					<div className="label-text" style={{ marginBottom: "var(--space-2)" }}>
						Enter Party ID
					</div>
					<div style={{ display: "flex", gap: "var(--space-2)" }}>
						<input
							className="form-control"
							type="text"
							value={partyId}
							onChange={(e) => setPartyId(e.target.value)}
							placeholder="e.g. TUMBO123"
							style={{ flex: 1, fontSize: "1.1rem", padding: "var(--space-4)" }}
						/>
						<Link to={"/p/" + partyId}>
							<button
								type="button"
								disabled={!validId}
								style={{
									height: "100%",
									padding: "0 var(--space-5)",
									borderRadius: "var(--radius-md)",
									border: "none",
									background: validId ? "var(--accent)" : "var(--bg-elevated)",
									color: validId ? "#fff" : "var(--text-muted)",
									fontWeight: 700,
									fontSize: "1rem",
									cursor: validId ? "pointer" : "default",
									fontFamily: "var(--font-ui)",
									transition: "background 120ms, color 120ms",
									boxShadow: validId ? "0 2px 12px rgba(255,107,107,0.3)" : "none",
								}}
							>
								Join
							</button>
						</Link>
					</div>
				</div>

				{/* Divider */}
				<div style={{
					display: "flex",
					alignItems: "center",
					gap: "var(--space-3)",
					color: "var(--text-muted)",
					fontSize: "0.75rem",
					letterSpacing: "0.08em",
					textTransform: "uppercase",
					fontWeight: 600,
					margin: "var(--space-2) 0",
				}}>
					<div style={{ flex: 1, height: 1, background: "var(--border)" }} />
					Or
					<div style={{ flex: 1, height: 1, background: "var(--border)" }} />
				</div>

				{/* Host — secondary */}
				<Link to="/p" style={{ textDecoration: "none" }}>
					<button
						type="button"
						style={{
							width: "100%",
							padding: "var(--space-4)",
							fontSize: "1rem",
							borderRadius: "var(--radius-lg)",
							background: "transparent",
							border: "1.5px solid var(--border-strong)",
							color: "var(--text-primary)",
							fontWeight: 600,
							fontFamily: "var(--font-ui)",
							cursor: "pointer",
						}}
					>
						Start a new party
					</button>
				</Link>
			</div>

			{/* Bottom: Discord + tagline */}
			<div style={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				gap: "var(--space-3)",
			}}>
				<a
					href="https://discord.gg/6XtrW2WW"
					target="_blank"
					rel="noopener noreferrer"
					style={{
						display: "flex",
						alignItems: "center",
						gap: "var(--space-2)",
						color: "var(--text-secondary)",
						textDecoration: "none",
						fontSize: "0.85rem",
						fontWeight: 600,
						padding: "var(--space-2) var(--space-4)",
						borderRadius: "var(--radius-pill)",
						border: "1px solid var(--border)",
						transition: "color var(--duration-fast) var(--ease-out), border-color var(--duration-fast) var(--ease-out)",
					}}
					onMouseEnter={e => {
						(e.currentTarget as HTMLAnchorElement).style.color = "#5865F2";
						(e.currentTarget as HTMLAnchorElement).style.borderColor = "rgba(88,101,242,0.4)";
					}}
					onMouseLeave={e => {
						(e.currentTarget as HTMLAnchorElement).style.color = "var(--text-secondary)";
						(e.currentTarget as HTMLAnchorElement).style.borderColor = "var(--border)";
					}}
				>
					<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
						<path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057c.002.022.015.043.03.056a19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028c.462-.63.874-1.295 1.226-1.994a.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"/>
					</svg>
					Join our Discord
				</a>
				<div style={{
					color: "var(--text-muted)",
					fontSize: "0.78rem",
					letterSpacing: "0.05em",
					textAlign: "center",
				}}>
					Play Together. Party Anywhere.
				</div>
			</div>
		</div>
	);
}

export default Home;
